export default __webpack_public_path__ + "static/media/filter_icon.6fa6b76c.svg";